module.exports = __webpack_public_path__ + "static/Logo-7535c8723a0ad24d584acd17977d14ec.png";